import React, { useContext, useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import UtilsBufer from '../Tools/UtilsBufer';
import Modal from 'react-bootstrap/Modal';
import { contextFormulario } from './PrincipalFormulario';
import ConsultasFormularios from '../Sql/ConsultasFormularios';
import ConsultasComunes from '../Sql/ConsultasComunes';
import BuscarEmpleado from '../BuscarEmpleado';
import ColaboradorTelegram from '../utilsComponentes/ColaboradorTelegram';
const server = process.env.REACT_APP_SERVER;
function ModalEditFormulario(props) {
    const { createCopy, soloVer } = props;
    const { regional, actualizar, setActualizar, setModalShow, tituloModal, selectItem } = useContext(contextFormulario);
    const [fechaIni, setFechaIni] = useState('');
    const [fechaFin, setFechaFin] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [titulo, setTitulo] = useState('');
    const [tipo, setTipo] = useState('');
    const [tipoRespuesta, setTipoRespuesta] = useState('U');
    const [idEncuesta, setIdEncuenta] = useState(0);
    const [obligatorio, setObligatorio] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [alcances, setAlcances] = useState([]);
    const [idAlcance, setIdAlcance] = useState(1);
    const [destinos, setDestinos] = useState([]);
    const [lista, setLista] = useState([]);
    const [tieneCaducidad, setTieneCaducidad] = useState();
    const [observacion, setObservacion] = useState('');
    const [listaTelegram, setListaTelegram] = useState([]);
    const [creadoPor,setCreadoPor] = useState(null);
    function validarCampos() {
        if (titulo !== '' && tipo !== '' && obligatorio !== '') {
            return true
        } else {
            return false
        }
    }
    const guardarFormulario = () => {
        if (validarCampos()) {
            fetch(`${server}/formulario/addFormulario`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    titulo, descripcion, tipo, tipoRespuesta, fechaIni,
                    fechaFin, regional, idEncuesta, obligatorio,
                    destinos, createCopy, tieneCaducidad,listaTelegram,
                    creadoPor
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.ok) {
                        setActualizar(!actualizar);
                        setModalShow(false);
                    } else {
                        MsgUtils.msgError(data.error)
                    }
                })
                .catch(err => MsgUtils.msgError(err));
        } else {
            MsgUtils.msgError("Complete la informacion")
        }
    }
    const agregarDestinatarios = async (valor) => {
        if (valor <= 3) {
            setIdAlcance(valor)
            var hayDestino = destinos.filter((item) => item.ID_ALCANCE == valor && item.ESTADO == true);
            if (hayDestino.length == 0) {
                switch (valor) {
                    case '1':
                        setDestinos([...destinos, { 'ID_ENCUESTA': idEncuesta, 'VALOR': 0, 'ID_ALCANCE': valor, 'DESCRIPCION': 'TODOS', 'ESTADO': true }])
                        break;
                    case '2':
                        setDestinos([...destinos, { 'ID_ENCUESTA': idEncuesta, 'VALOR': 1, 'ID_ALCANCE': valor, 'DESCRIPCION': 'SUPERVISION', 'ESTADO': true }])
                        break;
                    case '3':
                        setDestinos([...destinos, { 'ID_ENCUESTA': idEncuesta, 'VALOR': regional, 'ID_ALCANCE': valor, 'DESCRIPCION': regional == '990' ? 'CBBA' : 'SCRZ', 'ESTADO': true }])
                        break;
                }
            } else {
                MsgUtils.msgError("El destino ya existe")
            }
        } else {
            if (valor >= 4 && valor <= 7) {
                try {
                    var datos;
                    switch (valor) {
                        case '4'://sucursales
                            datos = await ConsultasComunes.getSucursales(regional);
                            break;
                        case '5'://areas
                            datos = await ConsultasComunes.getInfoCategoriasSys({ regional, 'tipo': 'PL' });
                            break;
                        case '6'://departamento
                            datos = await ConsultasComunes.getInfoCategoriasSys({ regional, 'tipo': 'DE' });
                            break;
                        case '7'://cargo
                            datos = await ConsultasComunes.getInfoCategoriasSys({ regional, 'tipo': 'TC' });
                            break;
                    }
                    if (datos.ok) {
                        setIdAlcance(valor);
                        setLista(datos.ok);
                        setShowModal(true);
                    } else {
                        MsgUtils.msgError(datos.error);
                    }
                } catch (error) {
                    MsgUtils.msgError(error.message);
                }
            } else {
                setIdAlcance(valor);
                setShowModal(true);
            }
        }
    }
    const obtenerAlcances = async () => {
        try {
            var data = await ConsultasFormularios.getAlcanceFormulario({ regional });
            if (data.ok) {
                setAlcances(data.ok);
            } else {
                MsgUtils.msgError(data.error)
            }
        } catch (error) {
            MsgUtils.msgError(error.message)
        }
    }
    function agregarValorDestino(valor) {
        var info, dato;
        if (idAlcance == 4) {
            info = lista.filter((item) => item.ID_SUCURSAL == valor)[0].SUCURSAL;
            dato = valor;
        } else if (idAlcance >= 5 && idAlcance <= 7) {
            info = lista.filter((item) => item.ID_CATEGORIA == valor)[0].CATEGORIA;
            dato = valor;
        } else {
            info = valor.NOMBREX;
            dato = valor.ID_EMPLEADO;
        }
        var hayDestino = destinos.filter((item) => item.VALOR == dato);
        setShowModal(false);
        if (hayDestino.length == 0) {
            setDestinos([...destinos, { 'ID_ENCUESTA': idEncuesta, 'VALOR': dato, 'ID_ALCANCE': idAlcance, 'DESCRIPCION': info, 'ESTADO': true }]);
        } else {
            MsgUtils.msgError("Ya se encuentra el destino " + info)
        }
    }
    function eliminarDestio(valor) {
        var valorFiltrado = destinos.filter((item) => item.VALOR != valor.VALOR);
        var eliminado = destinos.filter((item) => item.ID_ALCANCE == valor.ID_ALCANCE && item.VALOR == valor.VALOR);
        eliminado[0].ESTADO = false;
        setDestinos([...valorFiltrado, ...eliminado])
    }
    function agregarColaborador(dato) {
        var hayEmpleado = listaTelegram.filter(item => item.ID_EMPLEADO == dato.ID_EMPLEADO);
        if (hayEmpleado.length == 0) {
            setListaTelegram([...listaTelegram, dato])
            setShowModal(false);
            setIdAlcance(-1);
        } else {
            MsgUtils.msgError("Ya existe el colaborador...")
        }
    }
    const eliminarColaborador=async(dato)=>{
        try {
            if(idEncuesta!=0){
                var result = await ConsultasFormularios.eliminarColaboradorChat({regional,'ID_ENCUESTA':idEncuesta,'ID_EMPLEADO':dato.ID_EMPLEADO});
                if(result.ok){
                    var filtrado = listaTelegram.filter(item=>item.ID_EMPLEADO!=dato.ID_EMPLEADO);
                    setListaTelegram([...filtrado]);
                    MsgUtils.msgCorrecto(result.ok)
                }else{
                    MsgUtils.msgError(result.error);
                }
            }else{
                var filtrado = listaTelegram.filter(item=>item.ID_EMPLEADO!=dato.ID_EMPLEADO);
                setListaTelegram([...filtrado]);
            }
        } catch (error) {
            MsgUtils.msgError(error.message);
        }
    }
    useEffect(() => {
        if (tituloModal === 'E') {
            setTitulo(selectItem.TITULO);
            setDescripcion(UtilsBufer.getText(selectItem.DESCRIPCION));
            setTipo(selectItem.TIPO);
            setTipoRespuesta(selectItem.TIPO_RESPUESTA);
            setFechaIni(new Date(selectItem.FECHA_INICIO).toISOString().substring(0, 10));
            setFechaFin(new Date(selectItem.FECHA_FIN).toISOString().substring(0, 10));
            setIdEncuenta(selectItem.ID_ENCUESTA);
            setObligatorio(selectItem.OBLIGATORIO);
            setDestinos(selectItem.DESTINOS);
            setTieneCaducidad(selectItem.TIENE_CADUCIDAD);
            setObservacion(selectItem.OBSERVACION);
            setListaTelegram(selectItem.NOTIFICAR);
            setCreadoPor(selectItem.CREADO_POR);
        }else{
            var infoUser = JSON.parse(localStorage.getItem('info'))
            setCreadoPor(infoUser.ID_EMPLEADO);
        }
        if (alcances.length == 0) {
            obtenerAlcances();
        }
    }, [])
    return (
        <>
            <div className='container-fluid py-2'>
                {tieneCaducidad != null && <div className="p-0 alert alert-secondary text-center fw-bold ">
                    {observacion}
                </div>}
                <div className='row row-cols-sm-1 row-cols-md-2 g-2'>
                    <div className='col'>
                        <div className="mb-3">
                            <label className="form-label text-light">Titulo</label>
                            <input type="text" className="form-control form-control-sm"
                                disabled={!soloVer}
                                value={titulo} onChange={(e) => setTitulo(e.target.value)} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label text-light">Descripción</label>
                            <textarea type="text" className="form-control form-control-sm"
                                disabled={!soloVer}
                                value={descripcion} onChange={(e) => setDescripcion(e.target.value)} />
                        </div>
                        <div className='mb-3'>
                            <label className='form-label text-light'>Tipo</label>
                            <select className="form-select form-select-sm btn-secondary " value={tipo}
                                disabled={!soloVer}
                                onChange={(e) => {
                                    if (['O', 'P', 'S', 'R'].includes(e.target.value)) {
                                        setTieneCaducidad('N');
                                        setObservacion("SIN FECHA LIMITE");
                                    } else {
                                        setTieneCaducidad('S');
                                        setObservacion("CON FECHA LIMITE");
                                    }
                                    setTipo(e.target.value)
                                }}>
                                <option value=''>NINGUNO</option>
                                <option value='N'>ENCUESTA</option>
                                <option value='E'>EVALUACIÓN</option>
                                <option value='O'>EXAMEN OCUPACIONAL</option>
                                <option value='P'>EXAMEN PRE-OCUPACIONAL</option>
                                <option value='S'>EXAMEN POST-OCUPACIONAL</option>
                                <option value='R'>EXAMEN RUTINARIO</option>
                            </select>
                        </div>
                        <div className='mb-3'>
                            <label className='form-label text-light'>Es Obligatorio</label>
                            <select className="form-select form-select-sm btn-secondary " value={obligatorio}
                                disabled={!soloVer}
                                onChange={(e) => setObligatorio(e.target.value)}>
                                <option value=''>NINGUNO</option>
                                <option value='S'>SI</option>
                                <option value='N'>NO</option>
                            </select>
                        </div>
                        <div className="mb-3">
                            <label className="form-label text-light">Fecha Inicio</label>
                            <input type="date" className="form-control form-control-sm"
                                disabled={!soloVer}
                                value={fechaIni} onChange={(e) => setFechaIni(e.target.value)} />
                        </div>
                        {tieneCaducidad != null && tieneCaducidad == 'S' && <div className="mb-3">
                            <label className="form-label text-light">Fecha Fin</label>
                            <input type="date" className="form-control form-control-sm"
                                disabled={!soloVer}
                                value={fechaFin} onChange={(e) => setFechaFin(e.target.value)} />
                        </div>}
                        <div className="mb-3">
                            <label className="form-label text-light">Alcance De la Encuesta</label>
                            {soloVer == true && <select className="form-select form-select-sm" value={-1}
                                onChange={(e) => agregarDestinatarios(e.target.value)}>
                                <option value={-1} selected>NINGUNO</option>
                                {alcances.map((item, index) => {
                                    return (
                                        <option value={item.ID_ALCANCE} key={index}>{item.DESCRIPCION}</option>
                                    )
                                })}
                            </select>}
                        </div>
                        <div className='mb-3 overflow-auto bg-light' style={{ maxHeight: '120px' }}>
                            {destinos.map((item, index) => {
                                if (item.ESTADO == true) {
                                    return (
                                        <div className='container-fluid bg-dark bg-gradient border border-light' key={index}>
                                            <div className='row row-cols g-1 m-0 p-0 '>
                                                <div className='col-10 my-auto text-light fw-bold'>
                                                    {item.DESCRIPCION}
                                                </div>
                                                <div className='col-2 my-auto'>
                                                    {soloVer == true && <button className='btn btn-sm btn-transparent text-danger'
                                                        onClick={() => eliminarDestio(item)}>
                                                        <i className="fa-solid fa-trash-can"></i></button>}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            })}
                        </div>
                    </div>
                    <div className='col'>
                        <div className='text-light fw bold'>
                            NOTIFICAR POR TELEGRAM <button className='btn btn-sm btn-success'
                                title='Agregar Colaboradores que tengan notificaciones, cuando responden a este formulario'
                                onClick={() => { setIdAlcance(1000); setShowModal(true); }}>
                                <i className="fa-solid fa-plus fa-2xl"></i></button>
                        </div>
                        <div className='overflow-auto' style={{ minHeight: '200px', maxHeight: '200px', border: '1px solid #fff', borderRadius: '10px' }}>
                            <ul className="list-group list-group-sm">
                                {listaTelegram.map((item, index) => {
                                    return (
                                        <li className="list-group-item mb-1" key={index}>
                                            <div className='row row-cols lh-1'>
                                                <div className='col-10' style={{fontSize:'13px'}}>
                                                    <div className=''>
                                                        {item.NOMBREX}
                                                    </div>
                                                    <div className=''>
                                                        {item.SUCURSAL}
                                                    </div>
                                                </div>
                                                <div className='col-2'>
                                                    <button className='btn btn-danger btn-sm'
                                                        title='Eliminar este colaborador'
                                                        onClick={()=>eliminarColaborador(item)}>
                                                        <i className="fa-solid fa-trash-can fa-2xl"></i></button>
                                                </div>
                                            </div>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                        {soloVer == true &&
                            <button className='btn btn-sm btn-success w-100 bg-gradient' onClick={() => guardarFormulario()}>
                                <i className="fa-solid fa-floppy-disk fa-xl"></i> Guardar
                            </button>}
                    </div>
                </div>
            </div>
            <Modal show={showModal} onHide={() => setShowModal(false)}
                size="md" backdrop="static"
                keyboard={false}
                aria-labelledby="contained-modal-title-vcenter"
                contentClassName='bg-secondary bg-gradient' centered>
                <Modal.Header closeButton closeVariant='white' bsPrefix='modal-header m-0 p-0 px-2'>
                    <Modal.Title>
                        <div className='text-light'>Agregar </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body bsPrefix='modal-body m-0 p-0'>
                    {idAlcance == 4 &&
                        <div className='container-fluid'>
                            <div className='text-light fw-bold text-center'>
                                Elegir la Sucursal
                            </div>
                            <select className="form-select form-select-sm"
                                onChange={(e) => { agregarValorDestino(e.target.value) }}>
                                <option value={-1} selected>NINGUNO</option>
                                {lista.map((item, index) => {
                                    return (
                                        <option value={item.ID_SUCURSAL} key={index}>{item.SUCURSAL}</option>
                                    )
                                })}
                            </select>
                        </div>
                    }
                    {(idAlcance == 5 || idAlcance == 6 || idAlcance == 7) &&
                        <div className='container-fluid'>
                            <div className='text-light fw-bold text-center'>
                                Elegir la categoria
                            </div>
                            <select className="form-select form-select-sm"
                                onChange={(e) => { agregarValorDestino(e.target.value) }}>
                                <option value={-1} selected>NINGUNO</option>
                                {lista.map((item, index) => {
                                    return (
                                        <option value={item.ID_CATEGORIA} key={index}>{item.CATEGORIA}</option>
                                    )
                                })}
                            </select>
                        </div>
                    }
                    {idAlcance == 8 &&
                        <BuscarEmpleado setShowModal1={setShowModal} setColaborador={agregarValorDestino} reg={regional} />
                    }
                    {idAlcance == 1000 &&
                        <ColaboradorTelegram reg={regional} collback={(dato) => agregarColaborador(dato)} />
                    }
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalEditFormulario
